<!-- records table -->
<p-table [value]="records" stripedRows class="records-table" [paginator]="records.length"
  [alwaysShowPaginator]="false" [rows]="20" [rowsPerPageOptions]="[5, 10, 20, 50, 100]" 
  [loading]="loadingRecords">
  <!-- records table header -->
  <ng-template #header>
    <tr>
      <th>{{ 'field.action' | translate }}</th>
      <th>{{ 'field.hour-begin' | translate }}</th>
      <th>{{ 'field.hour-end' | translate }}</th>
      <th class="actions-cell"></th>
    </tr>
  </ng-template>
  <ng-template #body let-record>
    <tr>
      <!-- icon cols -->
      <td>
        <span [class]="_.get(record, 'icon')"></span>
      </td>
      <!-- hour begin col -->
      <td>
        <span [innerHTML]="_.get(record, 'begin.record')"></span>
        <span class="pi pi-comments" [pTooltip]="_.get(record, 'begin.comments')" tooltipEvent="hover" 
          tooltipPosition="top" [escape]="false" *ngIf="_.get(record, 'begin.comments')"></span>
        <span [ngClass]="_.get(record, 'begin.status.icon')" [pTooltip]="_.get(record, 'begin.status.name')" 
          tooltipEvent="hover" tooltipPosition="top" *ngIf="_.get(record, 'begin.status.value') !== 'auto'"></span>
      </td>
      <!-- hour end col -->
      <td>
        <span [innerHTML]="_.get(record, 'end.record')"></span>
        <span class="pi pi-comments" [pTooltip]="_.get(record, 'end.comments')" tooltipEvent="hover" 
          tooltipPosition="top" [escape]="false" *ngIf="_.get(record, 'end.comments')"></span>
        <span [ngClass]="_.get(record, 'end.status.icon')" [pTooltip]="_.get(record, 'end.status.name')"
          tooltipEvent="hover" tooltipPosition="top" *ngIf="_.get(record, 'end.status.value') !== 'auto'"></span>
      </td>
      <!-- actions -->
      <td class="actions-cell">
        <!-- confirm records -->
        <span class="pi pi-thumbs-up clickable" [pTooltip]="'button.confirm-records' | translate"
          tooltipEvent="hover" tooltipPosition="top" (click)="confirmRecords(record)"
          *ngIf="_.includes([_.get(record, 'begin.status.value'), _.get(record, 'end.status.value')], 'manual')"></span>
        <!-- reject records -->
        <span class="pi pi-times clickable" [pTooltip]="'button.reject-records' | translate"
          tooltipEvent="hover" tooltipPosition="left" (click)="rejectRecords(record)"
          *ngIf="_.includes([_.get(record, 'begin.status.value'), _.get(record, 'end.status.value')], 'manual')"></span>
        <!-- delete records -->
        <span class="pi pi-trash clickable" [pTooltip]="'button.delete' | translate"
          tooltipEvent="hover" tooltipPosition="left" (click)="deleteRecord(record)"
          *ngIf="!_.includes([_.get(record, 'begin.status.value'), _.get(record, 'end.status.value')], 'manual')"></span>
      </td>
    </tr>
  </ng-template>
</p-table>
<div *ngIf="!loadingRecords" class="table-footer">
  <div *ngIf="!records.length" class="no-items">
    {{ 'table.no-items' | translate: { items: ('entity.timesheet' | translate) } }}...
  </div>
</div>
<!-- total day -->
<div class="page-header">
  <span class="page-title">
    <span>{{ 'field.hours-day' | translate }}</span>
    <span>{{ hoursDay }}</span>
  </span>
</div>
<!-- total month -->
 <div class="page-header month">
  <span class="page-title">
    <span>{{ 'field.hours-month' | translate }}</span>
    <span>{{ hoursMonth }}</span>
  </span>
</div>
<!-- absences -->
<div class="absences">
  <div class="title">
    <span>{{ 'title.absences' | translate }}</span>
  </div>
  <div class="table">
    <p-table [value]="absences" stripedRows class="absences-table" [paginator]="absences.length"
      [alwaysShowPaginator]="false" [rows]="20" [rowsPerPageOptions]="[5, 10, 20, 50, 100]" 
      [loading]="loadingAbsences">
      <!-- absences table header -->
      <ng-template #header>
        <tr>
          <th>{{ 'field.reason' | translate }}</th>
          <th>{{ 'field.hour-begin' | translate }}</th>
          <th>{{ 'field.hour-end' | translate }}</th>
          <th class="icon-cell" *ngIf="showAbsenceComments"></th>
          <th class="actions-cell" *ngIf="allowEdit"></th>
        </tr>
      </ng-template>
      <ng-template #body let-absence>
        <tr>
          <!-- reason col -->
          <td>
            <span [innerHTML]="_.get(absence, 'typeName')"></span>
          </td>
          <!-- hour begin col -->
          <td>
            <span [innerHTML]="_.get(absence, 'hourBegin')"></span>
          </td>
          <!-- hour end col -->
          <td>
            <span [innerHTML]="_.get(absence, 'hourEnd')"></span>
          </td>
          <!-- comments col -->
          <td class="icon-cell" *ngIf="showAbsenceComments">
            <span class="pi pi-comments" [pTooltip]="absence.comments"
              tooltipEvent="hover" tooltipPosition="top" *ngIf="absence.comments"></span>
          </td>
          <!-- actions -->
          <td class="actions-cell" *ngIf="allowEdit">
            <!-- edit absence -->
            <span class="pi pi-pencil clickable" [pTooltip]="'button.edit' | translate"
              tooltipEvent="hover" tooltipPosition="top" (click)="editAbsence(absence)"></span>
            <!-- delete absence -->
            <span class="pi pi-trash clickable" [pTooltip]="'button.delete' | translate"
              tooltipEvent="hover" tooltipPosition="left" (click)="deleteAbsence(absence)"></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div *ngIf="!loadingAbsences" class="table-footer">
      <div *ngIf="!absences.length" class="no-items">
        {{ 'table.no-items' | translate: { items: ('entity.absence' | translate) } }}...
      </div>
    </div>
  </div>
</div>
